import { useNavigate } from 'react-router-dom';
import DiscountLabel from '../../assets/DiscountLabel.png';
import TruncatedText from "../../Utils/TruncatedText";
import { useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Card,
  CardContent,
  CardMedia,
  Skeleton,
} from "@mui/material";
import Ribbon from '../../assets/ribbon.png'
import SearchIcon from "@mui/icons-material/Search";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";
import TuneIcon from "@mui/icons-material/Tune";
import SearchBar from '../VmList/SearchVm';
const InventoryComponent = ({ items,inventroyMsg,loadingVmdata, onIncrement, onDecrement , setFilterFlag,fetchCategories,setShowSearchfiled}) => {

  const slot = localStorage.getItem("Global_Slot_id");
  //console.log("items",items)
    const [view, setView] = useState("grid"); // grid | list
  const navigate=useNavigate()
const [msg,setMsg]=useState("Loading....")
setTimeout(() => {
  setMsg("No Data Found")
}, 1000);
  
  const GridSkeleton = () => (
    <Card sx={{ borderRadius: 3, p: 1 }}>
      <Skeleton variant="rectangular" height={90} sx={{ borderRadius: 2 }} />
      <Skeleton height={18} sx={{ mt: 1 }} />
      <Skeleton height={14} width="60%" />
      <Skeleton height={32} sx={{ mt: 1, borderRadius: 1 }} />
    </Card>
  );

  const ListSkeleton = () => (
    <Card sx={{ borderRadius: 3, p: 1 }}>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Skeleton
          variant="rectangular"
          width={72}
          height={72}
          sx={{ borderRadius: 2 }}
        />
        <Box sx={{ flex: 1 }}>
          <Skeleton height={16} width="80%" />
          <Skeleton height={14} width="60%" />
          <Skeleton height={14} width="40%" />
          <Skeleton height={28} width={90} sx={{ mt: 1 }} />
        </Box>
      </Box>
    </Card>
  );


   const GotoDetails=(e,data)=>{
        ///console.log("GotoDetails",data)
        const machineId=localStorage.getItem("machineId")
        navigate(`/productdetails/${machineId}/${data.mv_id}/${data.slot_id}`)
      }


const BROWN = "#6B3F2B";
const openFilter=()=>{
  fetchCategories()
   setFilterFlag(true)
}
const openSearch=()=>{
  setShowSearchfiled(true)
}
const hasItems = !!(items && items[0]);

  return (
    <>  
    

     <Box data-testid="grid-container" aria-hidden="false">
         {console.log("has---- ---",hasItems)}
          <Box>
            {/* HEADER */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={2}
            >
              <Typography fontSize={20} fontWeight={600} color={"rgb(113, 129, 152)"}>
                Explore Products
              </Typography>
      
              <Box>
                <IconButton onClick={(e)=>{openSearch()}}>
                  <SearchIcon />
                </IconButton>
      
                <IconButton onClick={() => setView(view === "grid" ? "list" : "grid")}>
                  {view === "grid" ? <ViewListIcon /> : <ViewModuleIcon />}
                </IconButton>
      
                <IconButton onClick={openFilter}>
                  <TuneIcon />
                </IconButton>
              </Box>
            </Box>
      
            {/* PRODUCTS */}
{/*             {console.log("items&&items[0]?",items&&items[0])} */}
                {loadingVmdata?


                <>
                {hasItems?
                <Box
              display="grid"
              gridTemplateColumns={view === "grid" ? "repeat(2, 1fr)" : "1fr"}
              gap={2}
            >
              {items &&
          items[0] &&
          items.map((item,index) =>
                view === "grid" ? (
                  /* ---------------- GRID CARD ---------------- */
            <>
            {items &&
  items.length > 0 &&
  items.map((item, index) =>
    view === "grid" ? (
      <Card
        key={item.id}
        sx={{
          borderRadius: 3,
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        }}
         onClick={(e) => GotoDetails(e, item)}
      >
        {/* IMAGE */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: "10px",
            paddingTop: "20px",
          }}
        >
          <Box sx={{ height: "87px", width: "90%" }}>
            <CardMedia
              component="img"
              image={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${item.image_path}`}
              sx={{
                objectFit: "contain",
                height: "100%",
                width: "100%",
              }}
            />
          </Box>
        </Box>

        <CardContent sx={{ pt: 0 }}>
          {/* TITLE */}
          <Typography
            fontSize={14}
            fontWeight={500}
            noWrap
            textAlign="center"
            mb={1}
          >
            {item.mv_name}
          </Typography>

          {/* PRICE SECTION */}
          <Box textAlign="center" display={"flex"} style={{   justifyContent: "center",alignItems: "center"}}>
            {item.mrp &&
              item.mrp !== item.offer_price && (
                <Typography
                  fontSize={12}
                  color="#94A3B8"
                  sx={{ textDecoration: "line-through" }}
                >
                  ₹ {item.mrp.toFixed(2)}
                </Typography>
              )}

            <Typography fontWeight={600}>
              &nbsp;&nbsp;₹ {item.offer_price.toFixed(2)}
            </Typography>
          </Box>

          {/* OFFER DISCOUNT */}
          {item.offer_details && (

                                    <Box sx={{display:"flex",justifyContent: "center"}}>
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${Ribbon})`, // 🔁 Replace path
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        width: 120, // adjust width as per image
        height: 30, // adjust height as per image
        px: 2,
        py: 1,
        color: "#007A3D",
        fontWeight: 700,
        userSelect: "none",fontSize:"10px"
        
      }}
    >
      {item.offer_details.flatAmount}
                {item.offer_details.flatTypeId === 1 && " ₹ "}
                {item.offer_details.flatTypeId === 2 && "% "}
                {item.offer_details.couponType === "CashBack" && "Cashback"}
                {item.offer_details.couponType === "Discount" && " OFF"}
    </Box>
    </Box>
          )}

          {/* STOCK LEFT */}
          <Typography
            fontSize={12}
            color="text.secondary"
            textAlign="center"
            mb={1}
          >
            Item left. {item.active_count}
          </Typography>

          {/* ADD / COUNTER */}
          {item.mycount > 0 ? (
            <Box
              sx={{
                border: "2px solid #00B177",
                display: "flex",
                height: 32,
                backgroundColor: "#00B177",
                color: "#fff",
                justifyContent: "space-between",
                alignItems: "center",
                px: 1.5,
                borderRadius: "7px",
                cursor: "pointer",
              }}
            >
              <Typography
                onClick={(e) =>
                  onDecrement(e, index, item.slot_id, item.mycount)
                }
                sx={{ cursor: "pointer", fontWeight: 600 }}
              >
                −
              </Typography>

              <Typography fontWeight={600}>
                {item.mycount}
              </Typography>

              <Typography
                onClick={(e) =>
                  onIncrement(
                    e,
                    index,
                    item.slot_id,
                    item.mycount,
                    "add"
                  )
                }
                sx={{ cursor: "pointer", fontWeight: 600 }}
              >
                +
              </Typography>
            </Box>
          ) : item.active_count > 0 && item.active ? (
            <Box
              onClick={(e) =>
                onIncrement(
                  e,
                  index,
                  item.slot_id,
                  item.mycount,
                  "add"
                )
              }
              sx={{
                border: "2px solid #00B177",
                height: 32,
                backgroundColor: "rgba(0, 177, 119, 0.04)",
                color: "#00B177",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "7px",
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              ADD
            </Box>
          ) : (
            <Box
              sx={{
                height: 32,
                backgroundColor: "#8080803d",
                color: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "7px",
                fontWeight: 600,
              }}
            >
              ADD
            </Box>
          )}
        </CardContent>
      </Card>
    ) : null
  )}

            
            </>
                ) : (
                  /* ---------------- LIST CARD ---------------- */
              <Card
  key={item.id}
  sx={{
    display: "flex",
    flexDirection: "column",
    borderRadius: 3,
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    p: 1,
    mb: 1,
  }}
    onClick={(e) => GotoDetails(e, item)}
>
  {/* ================= MAIN CONTENT ================= */}
  <Box sx={{ display: "flex", alignItems: "center" }}>
    {/* Image */}
    <Box
      sx={{
        width: 72,
        height: 72,
        borderRadius: 2,
        overflow: "hidden",
        background: "#fff",
        flexShrink: 0,
      }}
    >
      <img
        src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${item.image_path}`}
        alt={item.mv_name}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    </Box>

    {/* Details */}
    <Box sx={{ ml: 1.5, flex: 1 }}>
      {/* Title + Tray */}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
          <TruncatedText text={item.mv_name} limit={20} />
        </Typography>
        <Typography sx={{ fontSize: 12, color: "#94A3B8" }}>
       
          Tray <TruncatedText text={item?.slot_id?.toString()} limit={1} />
        </Typography>
      </Box>

      {/* Description */}
      <Typography sx={{ fontSize: 12, color: "#94A3B8" }}>
        <TruncatedText text={item.mv_description} limit={25} />
      </Typography>

      {/* Left */}
      <Typography sx={{ fontSize: 12, color: "#718198" }}>
        {item.active_count > 0 ? `${item.active_count} Left` : "0 Left"}
      </Typography>

      {/* Price + Add */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 0.5,
        }}
      >
        {/* Price */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {item.mrp !== item.offer_price && (
            <Typography
              sx={{
                fontSize: 13,
                color: "#94A3B8",
                textDecoration: "line-through",
                mr: 0.5,
              }}
            >
              ₹{item.mrp.toFixed(2)}{" "}
            </Typography>
          )}
          <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
           ₹{item.offer_price.toFixed(2)}
          </Typography>
        </Box>

        {/* ADD / COUNTER */}
        {item.mycount > 0 ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: 90,
              height: 30,
              background: "#00B177",
              color: "#fff",
              borderRadius: 1.5,
              px: 1,
              fontWeight: 600,
            }}
          >
            <span
              style={{ cursor: "pointer" }}
              onClick={(e) =>
                onDecrement(e, index, item.slot_id, item.mycount)
              }
            >
              −
            </span>
            {item.mycount}
            <span
              style={{ cursor: "pointer" }}
              onClick={(e) =>
                onIncrement(e, index, item.slot_id, item.mycount, "add")
              }
            >
              +
            </span>
          </Box>
        ) : item.active_count > 0 && item.active ? (
          <Box
            onClick={(e) =>
              onIncrement(e, index, item.slot_id, item.mycount, "add")
            }
            sx={{
              width: 90,
              height: 30,
              border: "1.5px solid #00B177",
              borderRadius: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 13,
              fontWeight: 600,
              color: "#00B177",
              cursor: "pointer",
            }}
          >
            ADD
          </Box>
        ) : (
          <Box
            sx={{
              width: 90,
              height: 30,
              background: "#E5E7EB",
              borderRadius: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 13,
              fontWeight: 600,
              color: "#fff",
            }}
          >
            ADD
          </Box>
        )}
      </Box>
    </Box>
  </Box>

  {/* ================= OFFER SECTION (BOTTOM) ================= */}
  {item.offer_details && (
    <>
      <Box
        sx={{
          borderTop: "1px dashed rgba(148,163,184,0.6)",
          mt: 1,
          pt: 0.5,
        }}
      />

     <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          pl: 0.5,
        }}
      >
        <img
          src={DiscountLabel}
          alt="offer"
          style={{ width: 16, height: 16 }}
        />
        <Typography
          sx={{
            fontSize: 13,
            fontWeight: 600,
            color: "#006DFF",
          }}
        >
          {item.offer_details.flatAmount}
          {item.offer_details.flatTypeId === 1 && " Rs "}
          {item.offer_details.flatTypeId === 2 && "% "}
          {item.offer_details.couponType === "CashBack" && "Cashback"}
          {item.offer_details.couponType === "Discount" && " OFF"}
        </Typography>
      </Box> 

    </>
  )}
</Card>

                )
              )}
      
            </Box>:<>
            <div style={{height:"50vw"}}>
            <h1 style={{color:"black",textAlign:"center"}}>{msg}</h1></div></>}
            
            </>:<>
            
            
                        :
            <>

  <Box
    display="grid"
    gridTemplateColumns="repeat(2, 1fr)"
    gap={2}
  >
    {Array.from({ length: 10 }).map((_, index) => (
      <GridSkeleton key={index} />
    ))}
  </Box>

</>

            
            
            
            </>




}
          </Box>
    </Box>
    </>
  );
};

export default InventoryComponent;
